import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'TH_ERROR';
export const LOADING = 'TH_LOADING';
export const LOADING_DETAILS = 'TH_LOADING_DETAILS';
export const SUCCESS = 'TH_SUCCESS';
export const SUCCESS_DETAILS = 'TH_SUCCESS_DETAILS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

function detailsIsLoading(bool) {
  return {
    type: LOADING_DETAILS,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

export function successDetails(data) {
  return {
    type: SUCCESS_DETAILS,
    data: data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { allCustomFields, excludeWeekends, workStart, workEnd, holidays, dates, th } = allFilters;

    const customFields = customFieldsUtils.getSelected(allCustomFields, th);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, undefined, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const tData = await worker.Throughput({
        lists: th.selectedLists,
        labels: th.selectedLabels,
        members: th.selectedMembers,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        color: false
      });
      dispatch(success(tData));

      const thData = await worker.ThroughputHistogram({
        lists: th.selectedLists,
        labels: th.selectedLabels,
        members: th.selectedMembers,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: th.timeUnit,
        excludeZeroDays: th.excludeZeroDays,
        percentiles: allFilters.allPercentileValues
      });
      dispatch(successDetails(thData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getDetailsData(dates) {
  return async (dispatch, getState) => {
    dispatch(detailsIsLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { allCustomFields, excludeWeekends, workStart, workEnd, holidays, th } = allFilters;

    const customFields = customFieldsUtils.getSelected(allCustomFields, th);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, undefined, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const thData = await worker.ThroughputHistogram({
        lists: th.selectedLists,
        labels: th.selectedLabels,
        members: th.selectedMembers,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: th.timeUnit,
        excludeZeroDays: th.excludeZeroDays,
        percentiles: allFilters.allPercentileValues
      });
      dispatch(successDetails(thData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
